export default "__VITE_ASSET__W88UijO2__"